export * from './delete-konstante.component';
export * from './delete-konstante.component.module';